import { createSelector } from "reselect";
import { AppState } from "@shared/interfaces";

const selectPropertyState = (state: AppState) => state.properties;

export const getPropertiesFilter = () => createSelector(selectPropertyState, (state) => state.filter);

export const getSelectedProperties = () => createSelector(selectPropertyState, (state) => state.selectedPropertiesIds);

export const getProperties = () => createSelector(selectPropertyState, (state) => state.propertyList);

export const getProperty = () => createSelector(selectPropertyState, (state) => state.property);

export const getPropertiesCount = () => createSelector(selectPropertyState, (state) => state.total);

export const getPropertiesCheckForAssignState = () =>
  createSelector(selectPropertyState, (state) => state.propertyCheckForAssign);
